export default "__VITE_PUBLIC_ASSET__a3ba41e8__"